module.exports = "pegasus_template/assets/background-patterns/escheresque.png";